const LOCAL_STORAGE_KEY = {
    TOKEN: 'autentika_app_token',
    ADMIN_ROLE: 'admin_role_access',
    EMAIL_USER: 'email_user',
}


export default LOCAL_STORAGE_KEY;